import { color } from "minimum-ui/tokens";
import { rem } from "polished";
import styled from "styled-components";
import { composed } from "theme/utilities";

import Base from "./base";

/**
 * font-size: 14px, line-height: 16px, letter-spacing: -0.005em, font-weight: 400
 */
export const H5R = styled(Base).attrs(composed("h5"))`
  font-size: ${rem(14)};
  line-height: ${rem(16)};
  letter-spacing: -0.005em;
  font-weight: 400;
  color: ${color.neutral[400]};
`;

/**
 * font-size: 12px, line-height: 16px, letter-spacing: -0.005em, font-weight: 400
 */
export const H6R = styled(Base).attrs(composed("h6"))`
  font-size: ${rem(12)};
  line-height: ${rem(16)};
  letter-spacing: -0.005em;
  font-weight: 400;
  color: ${color.neutral[400]};
`;
